import React from 'react';
import { Navbar } from './Navbar';

export const CreatorNavbar: React.FC = () => <Navbar portal="creator" />;
